/**
 * @generated SignedSource<<453864ae99e6113eeaa9eaa5143411f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestartContentNodeAfterFailedInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type advanceTreeNavigation_RestartContentNodeAfterFailedMutation$variables = {
  input: RestartContentNodeAfterFailedInput;
};
export type advanceTreeNavigation_RestartContentNodeAfterFailedMutation$data = {
  readonly LearnV2: {
    readonly restartContentNodeAfterFailed: {
      readonly clientMutationId: string | null;
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type advanceTreeNavigation_RestartContentNodeAfterFailedMutation = {
  response: advanceTreeNavigation_RestartContentNodeAfterFailedMutation$data;
  variables: advanceTreeNavigation_RestartContentNodeAfterFailedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "RestartContentNodeAfterFailedPayload",
        "kind": "LinkedField",
        "name": "restartContentNodeAfterFailed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "advanceTreeNavigation_RestartContentNodeAfterFailedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "advanceTreeNavigation_RestartContentNodeAfterFailedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "051f6bcf2ce613853a18e906a4727f1a",
    "id": null,
    "metadata": {},
    "name": "advanceTreeNavigation_RestartContentNodeAfterFailedMutation",
    "operationKind": "mutation",
    "text": "mutation advanceTreeNavigation_RestartContentNodeAfterFailedMutation(\n  $input: RestartContentNodeAfterFailedInput!\n) {\n  LearnV2 {\n    restartContentNodeAfterFailed(input: $input) {\n      clientMutationId\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "415009a3503d904afedabfa08aa2ecba";

export default node;
